export default {
    bathroom: {
        name: "Bathroom",
        url: "fireai_icp/bathroom",
    },
    camping_area: {
        name: "Camping Area",
        url: "fireai_icp/camping_area",
    },
    dining_area: {
        name: "Dining Area",
        url: "fireai_icp/dining_area",
    },
    finance: {
        name: "Finance",
        url: "fireai_icp/finance",
    },
    fuel: {
        name: "Fuel",
        url: "fireai_icp/fuel",
    },
    incident_command: {
        name: "Incident Command",
        url: "fireai_icp/incident_command",
    },
    kitchen: {
        name: "Kitchen",
        url: "fireai_icp/kitchen",
    },
    laundry: {
        name: "Laundry",
        url: "fireai_icp/laundry",
    },
    logistics: {
        name: "Logistics",
        url: "fireai_icp/logistics",
    },
    operations: {
        name: "Operations",
        url: "fireai_icp/operations",
    },
    plans: {
        name: "Plans",
        url: "fireai_icp/plans",
    },
    safety: {
        name: "Safety",
        url: "fireai_icp/safety",
    },
    sleeping_quarters: {
        name: "Sleeping Quarters",
        url: "fireai_icp/sleeping_quarters",
    },
    warehouse: {
        name: "Warehouse",
        url: "fireai_icp/warehouse",
    },
}
